import { apiRequest } from "./api-request";
import { TobisNotConfiguredError } from "./tobis";

// Client fuer die Merkliste (/tobis-api/favorites, app.favorite/V0115). Eigene
// Datei und nicht in lib/tobis.ts: die Merkliste ist die erste Tobis-Sicht, die
// nicht "was liegt im Bestand" beantwortet, sondern "was habe ICH markiert" -
// dieselbe Trennung, die tobis-freshness.ts schon vormacht. lib/tobis.ts ist mit
// 1200 Zeilen ausserdem gross genug.

export type TobisFavoriteKind = "title" | "person";

export interface TobisFavorite {
  kind: TobisFavoriteKind;
  /** model.title.id beim Titel, model.talent_unified.person_id bei der Person. */
  refId: string;
  name: string | null;
  /** Poster bzw. Portrait. null bedeutet Platzhalter, nicht Fehler. */
  imageUrl: string | null;
  /** Nur beim Titel gesetzt. */
  year: number | null;
  /** Nur bei der Person gesetzt: Zahl der Rollen. */
  creditCount: number | null;
  createdAt: string;
}

function pfad(kind: TobisFavoriteKind, refId: string): string {
  return `tobis-api/favorites/${kind}/${encodeURIComponent(refId)}`;
}

/** Wirft TobisNotConfiguredError (501), wenn keine tobis-Datenbank haengt - wie fetchTobisHome. */
export async function fetchFavorites(signal?: AbortSignal): Promise<TobisFavorite[]> {
  const { response } = await apiRequest("tobis-api/favorites", { signal });
  if (response.status === 501) throw new TobisNotConfiguredError();
  if (!response.ok) throw new Error(`tobis-api/favorites → ${response.status}`);
  return ((await response.json()) as { favorites: TobisFavorite[] }).favorites;
}

/**
 * Markieren. Idempotent (PUT, siehe Route) - zweimal markieren ist derselbe
 * Zustand, kein Fehler.
 *
 * Liefert die Id zurueck, unter der der Eintrag jetzt steht: bei einer
 * zusammengefuehrten Person kann das eine andere sein als die angefragte
 * (Normalisierung auf person_id, siehe addFavorite im BFF).
 */
export async function addFavorite(kind: TobisFavoriteKind, refId: string): Promise<string> {
  const { response } = await apiRequest(pfad(kind, refId), { method: "PUT", csrf: true });
  if (response.status === 501) throw new TobisNotConfiguredError();
  if (!response.ok) throw new Error(`${pfad(kind, refId)} → ${response.status}`);
  return ((await response.json()) as { refId: string }).refId;
}

export async function removeFavorite(kind: TobisFavoriteKind, refId: string): Promise<void> {
  const { response } = await apiRequest(pfad(kind, refId), { method: "DELETE", csrf: true });
  if (response.status === 501) throw new TobisNotConfiguredError();
  if (!response.ok) throw new Error(`${pfad(kind, refId)} → ${response.status}`);
}
